<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.mobile"
    persistent
    width="600"
  >
    <v-progress-linear
      v-if="updatingCommissions"
      indeterminate
    ></v-progress-linear>

    <v-card>
      <v-toolbar flat tile class="flex-grow-0 mb-4">
        <v-toolbar-title class="title">
          {{ variableCommissionLabel }}
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="d-flex flex-column">
        <v-form @submit="changeVariableCommissions">
          <v-alert
            v-if="errorMessage"
            class="mb-4"
            type="error"
            icon="mdi-information"
            dense
          >
            {{ errorMessage }}
          </v-alert>
          <v-alert
            :class="errorMessage ? 'my-4' : 'mb-4'"
            color="orange"
            v-if="alertAttention"
            type="warning"
            icon="mdi-information"
            dense
          >
            {{ alertAttention }}
          </v-alert>

          <p v-html="$t('variableCommissions.description')"></p>

          <div class="pa-0 ma-0 mb-2">
            <v-row>
              <v-col cols="4" class="pb-0 mb-0 overline">
                {{ $t("from") }}: ({{ $t("labelCurrency") }})
              </v-col>
              <v-col cols="4" class="pb-0 mb-0 overline">
                {{ $t("until") }}: ({{ $t("labelCurrency") }})
              </v-col>
              <v-col cols="4" class="pb-0 mb-0 overline">
                {{ $t("commission") }}: (%)
              </v-col>
            </v-row>

            <div v-if="loading" class="text-center py-12">
              <v-progress-circular
                absolute
                color="info"
                indeterminate
              ></v-progress-circular>
            </div>

            <div v-else>
              <!-- ROW 1 -->
              <v-row
                class="d-flex align-center"
                v-for="(row, index) in comissions"
                :key="index"
              >
                <v-col cols="4">
                  <v-text-field
                    v-model="row.from"
                    ref="from"
                    outlined
                    dense
                    clearable
                    type="number"
                    hide-details
                    @input="validValueOf(index)"
                    :disabled="
                      disabled == row.errorOf ? updatingCommissions : true
                    "
                    :error="row.errorOf"
                    onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="row.until"
                    ref="until"
                    outlined
                    dense
                    clearable
                    type="number"
                    hide-details
                    @input="validValueUntil(index)"
                    :disabled="
                      disabled == row.errorUntil ? updatingCommissions : true
                    "
                    :error="row.errorUntil"
                    onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
                  ></v-text-field>
                </v-col>
                <v-col :cols="isDeleting ? 3 : 4">
                  <v-text-field
                    v-model="row.percentage"
                    outlined
                    dense
                    clearable
                    type="number"
                    hide-details
                    @input="validValueComission(index)"
                    :error="row.errorComission"
                    :disabled="
                      disabled == row.errorComission
                        ? updatingCommissions
                        : true
                    "
                    onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
                  ></v-text-field>
                </v-col>

                <v-col v-if="isDeleting" cols="1">
                  <v-checkbox
                    v-model="row.markedForDeletion"
                    class="my-0 py-0"
                    hide-details
                    :disabled="disabledRemoveCheckboxRows.includes(index)"
                  ></v-checkbox>
                </v-col>
              </v-row>

              <v-row v-if="canEditVariableComissionAffiliate">
                <v-col cols="12">
                  <v-btn
                    class="mr-2 white black--text"
                    x-small
                    :disabled="isDeleting && selectedForDeletion.length === 0"
                    @click="removeRow(isDeleting)"
                  >
                    {{ isDeleting ? $t("remove") : $t("removeTrack") }}
                  </v-btn>
                  <v-btn
                    color="info"
                    x-small
                    @click="addRow()"
                    :disabled="errorMessage != '' || isDeleting"
                  >
                    {{ $t("addNewTrack") }}
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </div>

          <v-divider v-if="canEditVariableComissionAffiliate" />

          <v-card-actions v-if="canEditVariableComissionAffiliate" class="pa-4">
            <v-spacer></v-spacer>
            <v-btn class="ml-2 white black--text" small @click="cancel">
              {{ $t("toCancel") }}
            </v-btn>
            <v-btn
              small
              type="submit"
              color="primary"
              @click.prevent="changeVariableCommissions"
              :disabled="
                loading ||
                  updatingCommissions ||
                  errorMessage != '' ||
                  isDeleting
              "
            >
              {{ $t("toConfirm") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import hasFeeValue from "@/util/hasFeeValue";

export default {
  data: () => ({
    dialog: false,
    loading: false,
    updatingCommissions: false,
    disabled: false,
    comissions: [],
    errorMessage: "",
    alertAttention: "",
    isDeleting: false,
    absolute: true,
    disabledRemoveCheckboxRows: [],
  }),

  created() {
    this.$root.$on("openVariableCommissions", () => {
      this.dialog = true;
    });
  },

  computed: {
    canEditVariableComissionAffiliate() {
      return this.$permission("89");
    },
    selectedForDeletion() {
      if (this.comissions.length === 0) {
        return [];
      }

      return this.comissions.filter((commission) => {
        return (
          commission.markedForDeletion ||
          commission.errorOf ||
          commission.errorUntil ||
          commission.errorComission
        );
      });
    },
    variableCommissionLabel() {
      return this.$t("variableCommissions.label");
    },
    rangeDate() {
      return this.$store.state.range.date;
    },
    hasFeeValue() {
      return hasFeeValue;
    },
  },

  watch: {
    dialog(val) {
      if (val) {
        this.currentVariableCommissions();
      } else {
        this.loading = false;
        this.updatingCommissions = false;
        this.disabled = false;
        this.isDeleting = false;
        this.comissions = [];
        this.errorMessage = "";
        this.alertAttention = "";
        this.disabledRemoveCheckboxRows = [];
      }
    },
  },

  methods: {
    currentVariableCommissions() {
      this.loading = true;

      const isCollaborator = JSON.parse(localStorage.getItem("user_data"))
        .isCollaborator;

      const endpoint = isCollaborator
        ? "/colab/affiliates/getAffiliatesVariableCommissionRange"
        : "/administrator/affiliates/getAffiliatesVariableCommissionRange";

      this.$axios
        .post(endpoint)
        .then((res) => {
          this.comissions = res.data.dados.map((item, index) => {
            const row = {
              order: index + 1,
              errorOf: false,
              errorUntil: false,
              errorComission: false,
              markedForDeletion: false,
            };
            Object.assign(row, item);
            return row;
          });
        })
        .catch(() => {
          this.comissions = [];
        })
        .finally(() => {
          this.loading = false;
        });

      if (isCollaborator && !this.canEditVariableComissionAffiliate) {
        this.disabled = true;
      }
    },

    changeVariableCommissions() {
      this.updatingCommissions = true;

      const body = {
        deleteAllCommissions: "0",
      };

      if (this.comissions.length > 0) {
        for (let i = 0; i < this.comissions.length; i++) {
          var obj = this.comissions[i];
          for (const [key, value] of Object.entries(obj)) {
            if (
              key != "errorOf" &&
              key != "errorUntil" &&
              key != "errorComission"
            ) {
              body[`${key}[${i}]`] = value;
            }
          }
        }
      } else {
        body.deleteAllCommissions = "1";
      }

      const isCollaborator = JSON.parse(localStorage.getItem("user_data"))
        .isCollaborator;

      const endpoint = isCollaborator
        ? "/colab/affiliates/affiliatesVariableCommissionRange"
        : "/administrator/affiliates/affiliatesVariableCommissionRange";

      this.$axios
        .post(endpoint, this.$formdata(body))
        .then((res) => {
          this.$store.commit("setFeedbackSnack", {
            msg: res.data.messages,
            color: "success",
          });
        })
        .catch((err) => {
          this.$store.commit("setFeedbackSnack", {
            msg: err.response.data.messages.error,
            color: "warning",
          });
        })
        .finally(() => {
          this.updatingCommissions = false;
        });
    },

    // Validation Of:
    validValueOf(index, shouldFocus = false) {
      // A validação deve ser a partir da linha 0

      if (index < 1) return;
      let valueFrom = Number(this.comissions[index].from);
      let valueUntilPrevious = Number(this.comissions[index - 1].until);
      if (valueUntilPrevious >= valueFrom) {
        if (shouldFocus) {
          setTimeout(() => {
            this.$refs.from[index].$el.querySelector("input").focus();
            this.comissions[index].errorOf = true;
            if (!this.disabledRemoveCheckboxRows.includes(index)) {
              this.comissions[index].markedForDeletion = true;
              this.disabledRemoveCheckboxRows.push(index);
            }
            this.disabled = true;
            this.errorMessage = this.$t("variableCommissions.errors.from");
          }, 100);
        } else {
          this.comissions[index].errorOf = true;
          if (!this.disabledRemoveCheckboxRows.includes(index)) {
            this.comissions[index].markedForDeletion = true;
            this.disabledRemoveCheckboxRows.push(index);
          }

          this.disabled = true;
          this.errorMessage = this.$t("variableCommissions.errors.from");
        }

        return;
      }
      if (valueFrom - valueUntilPrevious > 1) {
        if (shouldFocus) {
          setTimeout(() => {
            this.$refs.from[index].$el.querySelector("input").focus();
            this.comissions[index].errorOf = true;

            if (!this.disabledRemoveCheckboxRows.includes(index)) {
              this.comissions[index].markedForDeletion = true;
              this.disabledRemoveCheckboxRows.push(index);
            }

            this.disabled = true;
            this.errorMessage = this.$t(
              "variableCommissions.errors.fromSuggestion",
              { value: valueUntilPrevious + 1 }
            );
          }, 100);
        } else {
          this.comissions[index].errorOf = true;

          if (!this.disabledRemoveCheckboxRows.includes(index)) {
            this.comissions[index].markedForDeletion = true;
            this.disabledRemoveCheckboxRows.push(index);
          }

          this.disabled = true;
          this.errorMessage = this.$t(
            "variableCommissions.errors.fromSuggestion",
            { value: valueUntilPrevious + 1 }
          );
        }

        return;
      }

      if (this.disabledRemoveCheckboxRows.includes(index)) {
        const index = this.disabledRemoveCheckboxRows.indexOf(index);
        this.disabledRemoveCheckboxRows.splice(index, 1);
      }

      if (this.comissions[index]) {
        this.comissions[index].markedForDeletion = false;
        this.comissions[index].errorOf = false;
      }

      this.disabled = false;
      this.errorMessage = "";
    },

    // Validation Until:
    validValueUntil(index, shouldFocus = false) {
      let row = this.comissions[index];
      let valueFrom = Number(row.from);
      let valueUntil = Number(row.until);
      if (valueFrom > valueUntil) {
        if (shouldFocus) {
          setTimeout(() => {
            this.$refs.until[index].$el.querySelector("input").focus();
            this.comissions[index].errorUntil = true;

            if (!this.disabledRemoveCheckboxRows.includes(index)) {
              this.comissions[index].markedForDeletion = true;
              this.disabledRemoveCheckboxRows.push(index);
            }

            this.disabled = true;
            this.errorMessage = this.$t("variableCommissions.errors.until");
          }, 100);
        } else {
          this.comissions[index].errorUntil = true;

          if (!this.disabledRemoveCheckboxRows.includes(index)) {
            this.comissions[index].markedForDeletion = true;
            this.disabledRemoveCheckboxRows.push(index);
          }

          this.disabled = true;
          this.errorMessage = this.$t("variableCommissions.errors.until");
        }

        return;
      }

      if (valueFrom >= valueUntil) {
        if (shouldFocus) {
          setTimeout(() => {
            this.$refs.until[index].$el.querySelector("input").focus();
            this.comissions[index].errorUntil = true;

            if (!this.disabledRemoveCheckboxRows.includes(index)) {
              this.comissions[index].markedForDeletion = true;
              this.disabledRemoveCheckboxRows.push(index);
            }

            this.disabled = true;
            this.errorMessage = this.$t(
              "variableCommissions.errors.fromCantBeEqualOrLessThanUntil"
            );
          }, 100);
        } else {
          this.comissions[index].errorUntil = true;

          if (!this.disabledRemoveCheckboxRows.includes(index)) {
            this.comissions[index].markedForDeletion = true;
            this.disabledRemoveCheckboxRows.push(index);
          }

          this.disabled = true;
          this.errorMessage = this.$t(
            "variableCommissions.errors.fromCantBeEqualOrLessThanUntil"
          );
        }

        return;
      }

      if (this.disabledRemoveCheckboxRows.includes(index)) {
        const index = this.disabledRemoveCheckboxRows.indexOf(index);
        this.disabledRemoveCheckboxRows.splice(index, 1);
      }

      if (this.comissions[index]) {
        this.comissions[index].markedForDeletion = false;
        this.comissions[index].errorUntil = false;
      }

      this.disabled = false;
      this.errorMessage = "";
    },

    // Validation Comission:
    validValueComission(index) {
      let row = this.comissions[index];

      let valueComission = Number(row.percentage);

      if (valueComission < 0) {
        this.comissions[index].errorComission = true;
        this.disabled = true;
        this.errorMessage = this.$t(
          "variableCommissions.errors.comissionBelow0"
        );
        return;
      }

      if (valueComission > 20) {
        this.alertAttention = this.$t(
          "variableCommissions.errors.comissionAbove20"
        );
      } else {
        this.alertAttention = "";
      }

      if (!Number.isInteger(valueComission)) {
        this.comissions[index].errorComission = true;
        this.disabled = true;
        this.errorMessage = this.$t("commissionsOnlyInteger");
        this.alertAttention = "";
        return;
      }

      if (valueComission >= 100) {
        this.comissions[index].errorComission = true;
        this.disabled = true;
        this.errorMessage = this.$t("commissionEqualOrGreaterThan100");
        this.alertAttention = "";
        return;
      }

      this.disabled = false;
      this.comissions[index].errorComission = false;
      this.errorMessage = "";
    },

    removeRow(isDeleting) {
      if (isDeleting) {
        this.comissions = this.comissions.filter(
          ({ markedForDeletion, errorOf, errorUntil, errorComission }) =>
            !markedForDeletion && !errorOf && !errorUntil && !errorComission
        );

        this.isDeleting = false;

        this.comissions.forEach((_, i) => {
          // this.validValueComission(i);
          this.validValueUntil(i, true);
          this.validValueOf(i, true);
        });
      } else {
        this.isDeleting = true;
      }

      if (this.errorMessage == "") {
        this.disabled = false;
      }

      if (this.comissions.length === 0) {
        this.loading = false;
        this.updatingCommissions = false;
        this.disabled = false;
        this.isDeleting = false;
        this.comissions = [];
        this.errorMessage = "";
        this.alertAttention = "";
        this.disabledRemoveCheckboxRows = [];
      }
    },

    // Create a new commission track
    addRow() {
      let nextFrom = 1;

      if (this.comissions.length > 0) {
        nextFrom =
          Number(this.comissions[this.comissions.length - 1].until) + 1;
      }

      const order = this.comissions.length;
      const row = {
        order: order + 1,
        errorOf: false,
        errorUntil: false,
        errorComission: false,
        from: nextFrom,
        percentage: 0,
        until: 0,
        markedForDeletion: false,
      };

      this.comissions.push(row);

      this.validValueUntil(this.comissions.length - 1, true);
    },

    cancel() {
      if (this.isDeleting) {
        this.isDeleting = false;

        this.comissions = this.comissions.map((commission) => ({
          ...commission,
          markedForDeletion: commission.markedForDeletion
            ? commission.errorOf ||
              commission.errorUntil ||
              commission.errorComission
            : false,
        }));
      } else {
        this.dialog = false;
      }
    },
  },
};
</script>
